import { useTranslation } from "react-i18next";

import CsvDataGrid from "./CsvDataGrid";

export default function PointCsvDataGrid(props) {
    const { t } = useTranslation();
    const { points = [], pointApiStatusesByRowId = {}, components, componentsProps } = props;

    const dataColumns = [
        {
            field: "category",
            headerName: t("Category"),
            flex: 1,
            minWidth: 80,
            valueGetter: (params) => params.row.csvResult.success ? params.row.csvResult.data.category : null,
            valueFormatter: (val) =>
                val.value === "INPUT" ? t("Input") : t("Output"),
            csvFieldName: "category",
            dtoFieldName: "category",
        },
        {
            field: "controller_name",
            headerName: t("Controller"),
            flex: 1,
            minWidth: 80,
            valueGetter: (params) => {
                return params.row.csvResult.success ? params.row.csvResult.data.controller : null;
            },
            csvFieldName: "controller",
            dtoFieldName: "controller",
        },
        {
            field: "id",
            headerName: t("ID"),
            flex: 1,
            minWidth: 200,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.identifier : null,
            csvFieldName: "identifier",
            dtoFieldName: "identifier",
        },
        {
            field: "key",
            headerName: t("Key"),
            flex: 1,
            minWidth: 200,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.key : null,
            csvFieldName: "key",
            dtoFieldName: "key",
        },
        {
            field: "location",
            headerName: t("Location"),
            flex: 1,
            minWidth: 200,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.location : null,
            csvFieldName: "location",
            dtoFieldName: "location",
        },
        {
            field: "name",
            headerName: t("Name"),
            flex: 1,
            minWidth: 180,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.name : null,
            csvFieldName: "name",
            dtoFieldName: "name",
        },
        {
            field: "system",
            headerName: t("System"),
            flex: 1,
            minWidth: 180,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.system : null,
            csvFieldName: "system",
            dtoFieldName: "system",
        },
        {
            field: "tariff",
            headerName: t("Tariff"),
            flex: 1,
            minWidth: 180,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.tariff : null,
            csvFieldName: "tariff",
            dtoFieldName: "tariff",
        },
        {
            field: "display_on_floorplan",
            headerName: t("Display on floor Plan"),
            flex: 1,
            minWidth: 180,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.display_on_floorplan : null,
            csvFieldName: "display_on_floorplan",
            dtoFieldName: "display_on_floorplan",
        },
    ];

    return (
        <CsvDataGrid
            rowsData={points}
            apiStatusesByRowId={pointApiStatusesByRowId}
            dataColumns={dataColumns}
            components={components}
            componentsProps={componentsProps}
        />
    );
}
